import { Redirect } from 'react-router-dom';
import React from 'react';

// Internal
// --------

class PrimaryErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  componentDidCatch(error) {
    this.setState({
      hasError: true,
    });
  }

  render() {
    if (this.state.hasError) {
      return <Redirect to="/oops" />;
    }

    return this.props.children;
  }
}

// Exports
// -------

export default PrimaryErrorBoundary;
